module.exports = __webpack_public_path__ + "img/sec-01-toss.a3409782.svg";